import { useParams } from "react-router-dom";

export const useFunnelEditPageParams = () => {
  const { siteSlug = "", funnelSlug = "" } = useParams();

  return { siteSlug, funnelSlug };
};
